import React, { useEffect, useState } from 'react';

/**
 * Confetti animation component for celebrations
 * Creates physics-based confetti particles that fall and fade
 */
const Confetti = ({ duration = 3000, onComplete }) => {
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        // Generate 50 confetti particles with random properties
        const newParticles = Array.from({ length: 50 }, (_, i) => ({
            id: i,
            x: Math.random() * 100, // Random horizontal position (%)
            y: -10, // Start above viewport
            rotation: Math.random() * 360,
            color: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE'][Math.floor(Math.random() * 7)],
            size: Math.random() * 10 + 5, // 5-15px
            speedY: Math.random() * 3 + 2, // Fall speed
            speedX: (Math.random() - 0.5) * 2, // Horizontal drift
            rotationSpeed: (Math.random() - 0.5) * 10
        }));

        setParticles(newParticles);

        // Clean up after animation completes
        const timer = setTimeout(() => {
            if (onComplete) onComplete();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onComplete]);

    return (
        <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden">
            {particles.map((particle) => (
                <div
                    key={particle.id}
                    className="absolute"
                    style={{
                        left: `${particle.x}%`,
                        top: `${particle.y}%`,
                        width: `${particle.size}px`,
                        height: `${particle.size}px`,
                        backgroundColor: particle.color,
                        borderRadius: '50%',
                        transform: `rotate(${particle.rotation}deg)`,
                        animation: `
                            confetti-fall ${duration}ms ease-out forwards,
                            confetti-rotate ${duration / 2}ms linear infinite
                        `,
                        animationDelay: `${Math.random() * 200}ms`
                    }}
                />
            ))}
            <style>{`
                @keyframes confetti-fall {
                    0% {
                        transform: translateY(0) translateX(0);
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(110vh) translateX(${Math.random() * 40 - 20}vw);
                        opacity: 0;
                    }
                }
                @keyframes confetti-rotate {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default Confetti;
